"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _helpers = _interopRequireDefault(require("../helpers"));
var _uuid = require("uuid");
var binary = _interopRequireWildcard(require("bops"));
var _encryption = _interopRequireDefault(require("../encryption"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Money = exports["default"] = /*#__PURE__*/function (_Core) {
  function Money(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Money);
    _this = _callSuper(this, Money, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.init();
    _this.cryptoKey = props.cryptoKey;
    _this.publicKey = props.publicKey;
    _this.services = props.services;
    _this.ready = false;
    _this.myServices = ["dpm"];
    return _this;
  }
  (0, _inherits2["default"])(Money, _Core);
  return (0, _createClass2["default"])(Money, [{
    key: "getPeripheralsInfo",
    value: function () {
      var _getPeripheralsInfo = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var command, uuid, origin, requestUuid, encryptedPayload;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              command = 'System.PeripheralsManager.GetMoneyAcceptorsInfo';
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              requestUuid = ""; // Generate the encrypted payload
              _context.next = 7;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                timestamp: +new Date(),
                params: "{}"
              }, uuid, origin, requestUuid);
            case 7:
              encryptedPayload = _context.sent;
              _context.next = 10;
              return this.connection.invoke("messaging", encryptedPayload);
            case 10:
              _context.next = 12;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 12:
              return _context.abrupt("return", _context.sent);
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);
              console.error("Error in getPeripheralsInfo:", _context.t0);
              throw _context.t0;
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 15]]);
      }));
      function getPeripheralsInfo() {
        return _getPeripheralsInfo.apply(this, arguments);
      }
      return getPeripheralsInfo;
    }()
  }, {
    key: "getAcceptorStatus",
    value: function () {
      var _getAcceptorStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(acceptor) {
        var command, uuid, origin, requestUuid, payload;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              command = 'System.PeripheralsManager.GetAcceptorStatus';
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              requestUuid = "";
              _context2.next = 7;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                timestamp: +new Date(),
                params: {
                  "device": acceptor
                }
              }, uuid, origin, requestUuid);
            case 7:
              payload = _context2.sent;
              _context2.next = 10;
              return this.connection.invoke("messaging", payload);
            case 10:
              _context2.next = 12;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 12:
              return _context2.abrupt("return", _context2.sent);
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](0);
              console.error("Error in getAcceptorStatus:", _context2.t0);
              throw _context2.t0;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 15]]);
      }));
      function getAcceptorStatus(_x) {
        return _getAcceptorStatus.apply(this, arguments);
      }
      return getAcceptorStatus;
    }()
  }, {
    key: "changeAcceptorStatus",
    value: function () {
      var _changeAcceptorStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(acceptor, status) {
        var acc, sts, command, uuid, origin, requestUuid, payload;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              acc = acceptor.charAt(0).toUpperCase() + acceptor.slice(1);
              sts = status.charAt(0).toUpperCase() + status.slice(1);
              command = "System.PeripheralsManager.".concat(acc, "Acceptor").concat(sts);
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              requestUuid = "";
              _context3.next = 9;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                timestamp: +new Date(),
                params: "{}"
              }, uuid, origin, requestUuid);
            case 9:
              payload = _context3.sent;
              _context3.next = 12;
              return this.connection.invoke("messaging", payload);
            case 12:
              _context3.next = 14;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 14:
              return _context3.abrupt("return", _context3.sent);
            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](0);
              console.error("Error in changeAcceptorStatus:", _context3.t0);
              throw _context3.t0;
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 17]]);
      }));
      function changeAcceptorStatus(_x2, _x3) {
        return _changeAcceptorStatus.apply(this, arguments);
      }
      return changeAcceptorStatus;
    }()
  }, {
    key: "virtualMoneyInsert",
    value: function () {
      var _virtualMoneyInsert = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(device, amount) {
        var command, uuid, origin, requestUuid, payload;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              command = 'System.PeripheralsManager.VirtualMoneyInsert';
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              requestUuid = "";
              _context4.next = 7;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                timestamp: +new Date(),
                params: {
                  'device': device,
                  'amount': amount
                }
              }, uuid, origin, requestUuid);
            case 7:
              payload = _context4.sent;
              _context4.next = 10;
              return this.connection.invoke("messaging", payload);
            case 10:
              _context4.next = 12;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 12:
              return _context4.abrupt("return", _context4.sent);
            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](0);
              console.error("Error in virtualMoneyInsert:", _context4.t0);
              throw _context4.t0;
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 15]]);
      }));
      function virtualMoneyInsert(_x4, _x5) {
        return _virtualMoneyInsert.apply(this, arguments);
      }
      return virtualMoneyInsert;
    }()
  }, {
    key: "changeAcceptorStatusAll",
    value: function () {
      var _changeAcceptorStatusAll = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(bool) {
        var action, command, uuid, origin, requestUuid, payload, response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              action = bool ? 'Start' : 'Stop';
              command = "System.PeripheralsManager.AllAcceptors".concat(action);
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              requestUuid = "";
              _context5.next = 8;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                timestamp: +new Date(),
                params: "{}"
              }, uuid, origin, requestUuid);
            case 8:
              payload = _context5.sent;
              _context5.next = 11;
              return this.connection.invoke("messaging", payload);
            case 11:
              _context5.next = 13;
              return this.waitForResponse(command, uuid, this.services["dpm"]);
            case 13:
              response = _context5.sent;
              return _context5.abrupt("return", response);
            case 17:
              _context5.prev = 17;
              _context5.t0 = _context5["catch"](0);
              console.error("Error in changeAcceptorStatusAll:", _context5.t0);
              throw _context5.t0;
            case 21:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 17]]);
      }));
      function changeAcceptorStatusAll(_x6) {
        return _changeAcceptorStatusAll.apply(this, arguments);
      }
      return changeAcceptorStatusAll;
    }()
  }, {
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var payload;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              payload = {
                action: "System.PeripheralsManager.CheckReady",
                uuid: (0, _uuid.v4)(),
                origin: "sdk-" + this.appName,
                timestamp: +new Date(),
                request_uuid: "",
                data: "{}"
              };
              _context6.next = 4;
              return this.connection.invoke("messaging", payload);
            case 4:
              _logger["default"].info('Check Ready', "Checking if everything is ready", "Money");
              _context6.next = 11;
              break;
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);
              console.error("Error in getCheckReady:", _context6.t0);
              throw _context6.t0;
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 7]]);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }()
  }, {
    key: "waitForResponse",
    value: function () {
      var _waitForResponse = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(command, uuid, service) {
        var _this2 = this;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", new Promise(function (resolve, reject) {
                _this2.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(msg) {
                    var decryptedData, jsonObject;
                    return _regenerator["default"].wrap(function _callee7$(_context7) {
                      while (1) switch (_context7.prev = _context7.next) {
                        case 0:
                          if (!(msg.action === 'System.SDK.ServiceCall' && msg.requestUuid === uuid)) {
                            _context7.next = 13;
                            break;
                          }
                          _context7.prev = 1;
                          _context7.next = 4;
                          return _encryption["default"].decryptSymmetrically(service, msg.data);
                        case 4:
                          decryptedData = _context7.sent;
                          jsonObject = JSON.parse(decryptedData);
                          resolve(jsonObject.params);
                          _context7.next = 13;
                          break;
                        case 9:
                          _context7.prev = 9;
                          _context7.t0 = _context7["catch"](1);
                          console.error("Error decrypting data:", _context7.t0);
                          reject(new Error("Failed to decrypt data."));
                        case 13:
                        case "end":
                          return _context7.stop();
                      }
                    }, _callee7, null, [[1, 9]]);
                  }));
                  return function (_x10) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function waitForResponse(_x7, _x8, _x9) {
        return _waitForResponse.apply(this, arguments);
      }
      return waitForResponse;
    }()
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this3 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this3.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "startSymmetricKeyExchange",
    value: function () {
      var _startSymmetricKeyExchange = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(origin) {
        var service, fernetKey, fernetKeyBase64, symmetricExchangeData, encryptedByteArray, encryptedData, symmetricExchangePayload;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              service = this.services[origin]; // Import public key from service into CryptoKey
              _context9.next = 3;
              return crypto.subtle.importKey("spki", _helpers["default"].pemToArrayBuffer(service.publicKey), {
                name: "RSA-OAEP",
                hash: "SHA-256"
              }, true, ["encrypt"]);
            case 3:
              service.encryptionKey = _context9.sent;
              // Generate a 32-byte Fernet key
              fernetKey = _helpers["default"].getRandomString(32); // Ensure this is 32 characters long
              fernetKeyBase64 = btoa(fernetKey); // Base64 encode the key
              service.symmetricKey = fernetKeyBase64; // Store it as base64

              // Prepare the symmetric key exchange payload
              symmetricExchangeData = JSON.stringify({
                'serviceAbbreviation': 'sdk-' + this.appName,
                'serviceIdentification': 'System.SDK',
                'symmetricKey': fernetKeyBase64
              }); // Encrypt the payload with the public key
              _context9.next = 10;
              return crypto.subtle.encrypt({
                name: "RSA-OAEP",
                hash: "SHA-256"
              }, service.encryptionKey, new TextEncoder().encode(symmetricExchangeData));
            case 10:
              encryptedByteArray = _context9.sent;
              encryptedData = String.fromCharCode.apply(null, new Uint8Array(encryptedByteArray));
              symmetricExchangePayload = {
                'uuid': (0, _uuid.v4)(),
                'action': "".concat(service.serviceIdentification, ".SymmetricKeyExchange"),
                'origin': 'sdk-' + this.appName,
                'data': btoa(encryptedData) // Base64-encoded encrypted data
              };
              _context9.next = 15;
              return this.connection.invoke("messaging", symmetricExchangePayload);
            case 15:
              return _context9.abrupt("return", true);
            case 16:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function startSymmetricKeyExchange(_x11) {
        return _startSymmetricKeyExchange.apply(this, arguments);
      }
      return startSymmetricKeyExchange;
    }()
  }, {
    key: "handleMessages",
    value: function () {
      var _handleMessages = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(message) {
        var decryptedData, enc, decryptedObject, data;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return");
            case 2:
              _context10.t0 = message.action;
              _context10.next = _context10.t0 === 'System.SDK.ServiceNotification.Response' ? 5 : _context10.t0 === 'System.SDK.SymmetricKeyExchange' ? 14 : _context10.t0 === 'System.ServiceNotification' ? 32 : _context10.t0 === 'System.PeripheralsManager.Notify.Ready' ? 39 : 41;
              break;
            case 5:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context10.next = 7;
                break;
              }
              return _context10.abrupt("return");
            case 7:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              // Initialize SymmetricKeyExchange with this service
              _context10.next = 10;
              return this.startSymmetricKeyExchange(message.origin);
            case 10:
              _logger["default"].success("SymmetricExchange", "Exchange complete", message.origin);
              // Call getCheckReady after symmetric key exchange
              _context10.next = 13;
              return this.getCheckReady();
            case 13:
              return _context10.abrupt("return");
            case 14:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context10.next = 16;
                break;
              }
              return _context10.abrupt("return");
            case 16:
              _context10.prev = 16;
              _context10.next = 19;
              return crypto.subtle.decrypt({
                name: "RSA-OAEP"
              }, this.cryptoKey.privateKey, binary.from(message.data, "base64"));
            case 19:
              decryptedData = _context10.sent;
              enc = new TextDecoder("utf-8");
              decryptedObject = JSON.parse(enc.decode(decryptedData));
              this.services[message.origin].symmetricKey = decryptedObject.symmetricKey;
              _logger["default"].success("SymmetricExchange", "Exchange complete", message.origin);

              // Call getCheckReady after symmetric key exchange
              _context10.next = 26;
              return this.getCheckReady();
            case 26:
              _context10.next = 31;
              break;
            case 28:
              _context10.prev = 28;
              _context10.t1 = _context10["catch"](16);
              _logger["default"].error("SymmetricExchange", "Failed to decrypt: " + _context10.t1.message, message.origin);
            case 31:
              return _context10.abrupt("return");
            case 32:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context10.next = 34;
                break;
              }
              return _context10.abrupt("return");
            case 34:
              // Send our data
              data = JSON.parse(message.data);
              _context10.next = 37;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "".concat(data.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-" + this.appName,
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 37:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              return _context10.abrupt("return");
            case 39:
              // Handle the ready notification
              if (!this.ready) {
                this.ready = true;
                this.trigger("ready", true);
                _logger["default"].success("Initialization done", "Module is now ready", "Money");
              }
              return _context10.abrupt("return");
            case 41:
              return _context10.abrupt("break", 42);
            case 42:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[16, 28]]);
      }));
      function handleMessages(_x12) {
        return _handleMessages.apply(this, arguments);
      }
      return handleMessages;
    }()
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Money");
      var foundServices = this.detectServices();
      if (!foundServices) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Money");
      } else {
        this.ready = true;
        this.trigger("ready", true);
      }
      this.connection.on("messaging", this.handleMessages.bind(this));
    }
  }]);
}(_core["default"]);